import { useCallback, useState } from "react";
import { WizardStepId } from "../types";

interface UseWizardStepsProps {
  persistState: (stepId: WizardStepId, completedSteps: WizardStepId[]) => void;
}

export const useWizardSteps = ({ persistState }: UseWizardStepsProps) => {
  const [currentStep, setCurrentStep] = useState<WizardStepId>("welcome");
  const [completedSteps, setCompletedSteps] = useState<WizardStepId[]>([]);

  const advanceToStep = useCallback(
    (nextStep: WizardStepId, delay: number = 0) => {
      setTimeout(() => {
        setCurrentStep(nextStep);
        persistState(nextStep, completedSteps);
      }, delay);
    },
    [completedSteps, persistState],
  );

  const resetSteps = useCallback(() => {
    setCurrentStep("welcome");
    setCompletedSteps([]);
  }, []);

  return {
    currentStep,
    completedSteps,
    setCurrentStep,
    setCompletedSteps,
    advanceToStep,
    resetSteps,
  };
};
